<template>
    <div class="Tda">
        <main>
            <!-- section-TDA首屏 -->
            <section class="section-hero">
                <div class="hero">
                    <div class="tda-description-box">
                        <div class="tda-text-box">
                            <h1 class="heading-primary heading-primary-child">
                                综合学术能力评估(CACA)
                                <div class="heading-fifth">Comprehensive Academics Competency Assessment</div>
                            </h1>
                            <p class="tda-description">
                                <strong>综合学术能力评估(CACA，Comprehensive Academics Competency Assessment)</strong
                                >是一个面向具备数学或物理学科特长，特别是有志于参加高中或高校数学或物理学科培养类项目选拔的学生提供的水平测试。CACA
                                结合学科知识、核心素养、思维素质构建了从基础思维到综合能力的进阶性测评体系，旨在通过科学量化的评估与水平标定，帮助学生精准定位自身在数理领域的知识素养情况及发展潜能，为个性化学习路径规划提供数据支持。
                            </p>
                            <p class="tda-description small-hidden"
                                 style="text-indent: inherit;text-align: center;padding-top: 2rem;">
                                <a href="https://student.cssat.cn" style="padding: 1.6rem 6rem;" class="btn btn--full">立即申请报名 →</a>
                            </p>
                        </div>
                        <div class="tda-schedule-box">
                            <p class="tda-schedule-title">
                                <i class="ph ph-calendar-check schedule-icon"></i>
                                <span>考试时间安排</span>
                            </p>
                            <div class="tda-date-boxes">
                                <div class="date-box">
                                    <p class="test-date"><span>2025年11月29日</span></p>
                                    <p class="test-name">CACA-Pre</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2025年12月6日</span></p>
                                    <div class="date-box-row">
                                        <p class="test-name">CACA-Basic</p>
                                        <p class="test-name">CACA-Junior</p>
                                    </div>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2025年12月28日</span></p>
                                    <p class="test-name">CACA-Pre(Online)</p>
                                </div>
                                <div class="date-box">
                                    <p class="test-date"><span>2026年3月下旬或4月上旬</span></p>
                                    <div class="date-box-row">
                                        <p class="test-name">CACA-Pre</p>
                                        <p class="test-name">CACA-Basic</p>
                                    </div>
                                    <div class="date-box-row">
                                        <p class="test-name">CACA-Junior</p>
                                        <p class="test-name">CACA-Senior</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hero-bottom small-show">
                        <div class="hero-buttons">
                            <a href="https://student.cssat.cn" style="padding: 1.6rem 6rem;" class="btn btn--full">立即申请报名 →</a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- section-考试类别 -->
            <section class="section-grade-type section tab-area-container" style="padding-bottom: 0;">
                <div class="container">
                    <h2 class="heading-secondary heading-secondary--features">
                        <p class="section-title">
                            <span class="section-title-text">综合学术能力评估(CACA)类别</span>
                        </p>
                    </h2>
                    <div class="tab-area">
                        <div v-for="item in tabList"
                             :key="item"
                             :id="item"
                             :class="{
                                 'tab-area-item' :true,
                                 'is-active':activeTab==item,
                             }"
                             @click="changeActiveTab(item)">{{item}}
                        </div>
                    </div>
                </div>
            </section>

            <CACA-Pre v-if="activeTab=='CACA-Pre'"/>
            <CACA-Basic v-if="activeTab=='CACA-Basic'"/>
            <CACA-Junior v-if="activeTab=='CACA-Junior'"/>
            <CACA-Senior v-if="activeTab=='CACA-Senior'"/>
        </main>
    </div>
</template>

<script>
    import CACAPre from "./UI/CACA-Pre";
    import CACABasic from "./UI/CACA-Basic";
    import CACAJunior from "./UI/CACA-Junior";
    import CACASenior from "./UI/CACA-Senior";

    export default {
        name: 'Caca',
        metaInfo: {
            title: "CSSAT、CACA-综合学术能力评估",
            meta: [
                {
                    name: 'description',
                    content: '综合学术能力评估(CACA，Comprehensive Academics Competency Assessment)是一个面向具备数学或物理学科特长，特别是有志于参加高中或高校数学或物理学科培养类项目选拔的学生提供的水平测试。CACA结合学科知识、核心素养、思维素质构建了从基础思维到综合能力的进阶性测评体系，旨在通过科学量化的评估与水平标定，帮助学生精准定位自身在数理领域的知识素养情况及发展潜能，为个性化学习路径规划提供数据支持。'
                }
            ]
        },
        components: {CACAPre, CACABasic, CACAJunior, CACASenior},
        data() {
            return {
                tabList: ['CACA-Pre', 'CACA-Basic', 'CACA-Junior', 'CACA-Senior'],
            }
        },
        mounted() {
            let that = this;
            let hash = this.$route.hash;
            if (hash) {
                hash = hash.slice(1);
                that.scrollToElement(hash);
            }
        },
        methods: {
            changeActiveTab(val) {
                let that = this;
                that.$store.commit('setActiveTab', {
                    key: 'CACA',
                    tab: val
                });
            },
            scrollToElement(elementId) {
                const el = this.$el.querySelector(`#${elementId}`);
                if (el) {
                    window.scrollTo({
                        top: el.offsetTop,
                        behavior: 'smooth'
                    });
                }
            },
        },
        watch: {
            '$route'(to, from) {
                let that = this;
                let hash = to.hash;
                if (hash) {
                    hash = hash.slice(1);
                    that.scrollToElement(hash);
                }
            }
        },
        computed: {
            activeTab() {
                let that = this;
                return that.$store.getters.getActiveTab('CACA');
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/main--tda.css';
    @import '../assets/css/queries--tda.css';
    @import '../assets/scss/main--tda.scss';
    @import '../assets/scss/queries--tda.scss';
</style>
